import moment from 'moment';
import useFocusTrap from '../../useFocusTrap';
import AtlasIcon from './AtlasIcon';
import './AtlasContextPanel.css';
import { t } from '../../i18n';

// Painel contextual unificado do Atlas Vivo (fase 2.4 —
// docs/plans/overhaul-ux-atlas-vivo.md). Lugar, show (e futuramente rota/
// memória) abrem a MESMA região à direita com conteúdo específico. Só uma
// seleção por vez — a região é única, então nunca há dois drawers abertos.
function AtlasContextPanel({ selection, onClose, onEditTags }) {
  const panelRef = useFocusTrap(Boolean(selection), onClose);

  if (!selection) return null;

  const { kind, data } = selection;

  return (
    <aside ref={panelRef} className="av-contextpanel av-context" aria-label={t('web.context.panel.a11y')}>
      <div className="av-context-header">
        <span className="av-context-kind">{kind === 'concert' ? 'Show' : 'Lugar'}</span>
        <button type="button" className="av-context-close av-icon-btn" onClick={onClose} aria-label={t('web.context.closePanel')}>
          <AtlasIcon name="x" size={16} />
        </button>
      </div>

      {kind === 'place' && (
        <div className="av-context-body">
          <h2 className="av-context-title">{data.venue}</h2>
          {data.category && <p className="av-context-line">{data.category}</p>}
          {data.date && (
            <p className="av-context-meta">{moment(data.date).format('DD/MM/YYYY')}</p>
          )}
          {data.formatted_address && (
            <p className="av-context-line av-context-address">{data.formatted_address}</p>
          )}
          {Number(data.times_visited) > 0 && (
            <div className="av-context-stat">
              <strong>{data.times_visited}</strong>
              <span>{Number(data.times_visited) === 1 ? 'visita registrada' : 'visitas registradas'}</span>
            </div>
          )}
          {onEditTags && (
            <button
              type="button"
              className="av-context-action"
              onClick={() => onEditTags({ id: data.id, name: data.venue })}
            >
              🏷 Editar tags
            </button>
          )}
        </div>
      )}

      {kind === 'concert' && (
        <div className="av-context-body">
          <h2 className="av-context-title">{data.artist_name || 'Show'}</h2>
          {data.venue_name && <p className="av-context-line">{data.venue_name}</p>}
          {(data.city_name || data.country_name) && (
            <p className="av-context-line">
              {[data.city_name, data.country_name].filter(Boolean).join(', ')}
            </p>
          )}
          {data.event_date && (
            <p className="av-context-meta">{moment(data.event_date).format('DD/MM/YYYY')}</p>
          )}
        </div>
      )}
    </aside>
  );
}

export default AtlasContextPanel;
